module.exports = __webpack_public_path__ + "img/HealthHelp_Cognitive.5b318bdc.svg";